import React, { useState } from 'react';
import {Link, withRouter} from "react-router-dom";

import {
  AppBar,
  Toolbar,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { Close, Menu as MenuIcon, Home, Info, LocalBar, RestaurantMenu } from "@material-ui/icons";
import {fade} from "@material-ui/core/styles/colorManipulator";
import './common-styles.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // marginBottom: '10px'
  },
  title: {
    flexGrow: 1,
    color: '#F6EDD6',
    marginLeft: '20px',
    alignSelf: 'center',
  },
  logo: {
    height: '50px',
    cursor: 'pointer'
  },
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 1,
    // color: theme.palette.grey[500],
    // color: 'white',
  },
  sectionDesktop: {
    flexGrow: 1,
    display: 'none',
    textAlign: 'left',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    flexGrow: 1,
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));


const StyledMenu = ((props) => (
      <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        {...props}
        PaperProps={{
          style: {
            backgroundColor: props.shrinkheader ? fade('#242424', 0.9) : '#ffffff',
            border: 'none',
            marginTop: '4px',
            color: props.shrinkheader ? '#ffffff' : 'black'
          }
        }}
      />
));

const NavBar = ({ history, shrinkHeader }) => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleItemSelect = item => {
    setDrawerOpen(false);
    history.push(`/${item}`);
  };

  const handleHover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const mobileMenu = (
    <Drawer anchor='right' open={drawerOpen} onClose={() => setDrawerOpen(false)}>
      <IconButton aria-label="close" className={classes.closeButton} onClick={() => setDrawerOpen(false)}>
        <Close color="primary" />
      </IconButton>
      <List style={{ marginTop: '40px' }}>
        <ListItem button onClick={() => handleItemSelect('')}>
          <ListItemIcon><Home color="primary" /></ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem button onClick={() => handleItemSelect('menu')}>
          <ListItemIcon><RestaurantMenu color="primary" /></ListItemIcon>
          <ListItemText primary="Food Menu" />
        </ListItem>
        <ListItem button onClick={() => handleItemSelect('menu/beverages')}>
          <ListItemIcon><LocalBar color="primary" /></ListItemIcon>
          <ListItemText primary="Drinks Menu" />
        </ListItem>
        <ListItem button onClick={() => handleItemSelect('about-us')}>
          <ListItemIcon><Info color="primary" /></ListItemIcon>
          <ListItemText primary="About Us" />
        </ListItem>
        {/*<ListItem button onClick={() => handleItemSelect('services')}>*/}
        {/*  <ListItemIcon><Store color="primary" /></ListItemIcon>*/}
        {/*  <ListItemText primary="Services" />*/}
        {/*</ListItem>*/}
      </List>
      <div style={{ margin: '20px 20px auto 20px', paddingTop: '25px', borderTop: '2px dotted white' }}>
        <a href="tel:574-971-8674" style={{ textDecoration: 'none', color: 'white' }}>(574) 971-8674</a>
        <Typography style={{ marginTop: '10px' }}>231 Chicago Ave</Typography>
        <Typography>Goshen, IN 46526</Typography>
      </div>
    </Drawer>
  );

  return (
    <>
      <AppBar
        position="sticky"
        color="inherit"
        className='appbar'
        style={{
          backgroundColor: shrinkHeader ? fade('#242424', 0.75) : '#ffffff',
          transition: 'all .2s linear',
        }}>
        <Toolbar>

          <div className={classes.sectionMobile}>
            <Link
              to={'/'}
              style={{ textDecoration: 'none' }}
            >
              <Typography
                variant="h4"
                style={{
                  marginLeft: '10px',
                  marginTop: '5px',
                  color: shrinkHeader ? 'white': 'black',
                  fontSize: shrinkHeader ? '30px' : '40px',
                  transition: 'all .2s linear'
                }}
              >
                Castañeda Tacos
              </Typography>
            </Link>

            <div className={classes.title} />

            <IconButton
              style={{
                color: shrinkHeader ? 'white': 'black',
              }}
              aria-label="show more"
              // aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </div>

          <div className={classes.sectionDesktop}>
            <Link
              to={'/'}
              style={{ textDecoration: 'none' }}
            >
              <Typography
                variant="h4"
                style={{
                  marginTop: '5px',
                  marginLeft: '10px',
                  color: shrinkHeader ? 'white': 'black',
                  fontSize: shrinkHeader ? '30px' : '40px',
                  transition: 'all .2s linear'
                }}
              >
                Castañeda Tacos
              </Typography>
            </Link>
            <div className={classes.title} />
            <div>
              <Link to={'/menu'} className='nav-links'>
                <Button
                  color="primary"
                  style={{ fontSize: shrinkHeader ? '20px' : '26px' }}
                  // onClick={handleHover}
                  onClick={() => history.push('/menu')}
                  onMouseEnter={handleHover}
                >
                  Menu
                </Button>
              </Link>
              <StyledMenu
                id="menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{ onMouseLeave: handleClose }}
                shrinkheader={shrinkHeader}
              >
                  <MenuItem onClick={() => {
                    setAnchorEl(null);
                    history.push('/menu');
                  }}>
                    <ListItemIcon><RestaurantMenu color="primary" /></ListItemIcon>
                    <ListItemText primary="Food Menu" />
                  </MenuItem>
                  <MenuItem onClick={() => {
                    setAnchorEl(null);
                    history.push('/menu/beverages');
                  }}>
                    <ListItemIcon><LocalBar color="primary" /></ListItemIcon>
                    <ListItemText primary="Beverages Menu" />
                  </MenuItem>
              </StyledMenu>
              <Link to={'/about-us'} className='nav-links'><Button color="primary" style={{ fontSize: shrinkHeader ? '20px' : '26px' }}>About Us</Button></Link>
              {/*<Link to={'/services'} className='nav-links'><Button color="primary" style={{ fontSize: shrinkHeader ? '20px' : '26px' }}>Services</Button></Link>*/}
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {mobileMenu}
    </>
  );
};

export default withRouter(NavBar);
